import { t } from "i18next";
import { useEffect, useState } from "react";
import { getVideos } from "../../../../services/video";
import { Video } from "../../../../interfaces/video";
import { Button, Col, Form, Row } from "react-bootstrap";
import { LoadingSpinner } from "../../../general/loading-spinner";

export function AthleteVideoList() {
    const [videos, setVideos] = useState<Video[]>([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [hasMoreVideos, setHasMoreVideos] = useState(true);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        getVideos('', 1, 12)
            .then(response => {
                setVideos(response.data);
                setHasMoreVideos(response.data.length === 12);
                setCurrentPage(1);
                setLoaded(true);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    const handleSearchSubmit = (event: any) => {
        event.preventDefault();

        const s = event.target.search.value;
        setSearchTerm(s);

        getVideos(s, 1, 12)
            .then(response => {
                setVideos(response.data);
                setHasMoreVideos(response.data.length === 12);
                setCurrentPage(1);
            })
            .catch(error => {
                console.log(error);
            });
    }

    const handleLoadMore = () => {
        if (isLoadingMore || !hasMoreVideos) return;

        setIsLoadingMore(true);
        const nextPage = currentPage + 1;

        getVideos(searchTerm, nextPage, 12)
            .then(response => {
                setVideos(prevVideos => [...prevVideos, ...response.data]);
                setCurrentPage(nextPage);
                setHasMoreVideos(response.data.length === 12);
                setIsLoadingMore(false);
            })
            .catch(error => {
                console.log(error);
                setIsLoadingMore(false);
            });
    }

    return (
        <div className="video-list-container">
            <h1>
                { t('videos')}
            </h1>
            { !loaded && <LoadingSpinner /> }
            { loaded &&
                <div className="filters-container">
                    <Form onSubmit={ handleSearchSubmit }>
                        <Form.Group className="field-search" controlId="search">
                            <Form.Control type="search" placeholder={ t("Write to search") } />
                        </Form.Group>
                        <div className="actions">
                            <Button variant="primary" type="submit">
                                { t("search") }
                            </Button>
                        </div>
                    </Form>
                </div>
            }
            { loaded &&
                <div className="grid-container">
                    <Row>
                        { videos.map((v: Video) => {
                            return <Col key={ 'video-' + v.id } xs={12} md={6} lg={4} xl={3}>
                                <div className="video-card">
                                    <div className="heading">
                                        <div className="media">
                                            { v.media.length > 0 &&
                                                <video controls>
                                                    <source src={ v.media[0].url } />
                                                </video>
                                            }
                                        </div>
                                        <div className="meta">
                                            <div className="name">
                                                { v.name }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        })}
                    </Row>
                    { hasMoreVideos && (
                        <Row className="mt-4">
                            <Col className="text-center">
                                <Button
                                    variant="outline-primary"
                                    onClick={handleLoadMore}
                                    disabled={isLoadingMore}
                                >
                                    {isLoadingMore ? t('loading') + '...' : t('Load more')}
                                </Button>
                            </Col>
                        </Row>
                    )}
                </div>
            }
        </div>

    )
}